/* eslint-disable react/no-array-index-key */
import {
  Dispatch,
  FC,
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
} from 'react';

import { useRouter } from 'next/router';

import { ISidebarItem } from '~/common/interfaces/i-sidebar-item';
import { GenericMenuItem } from '~/common/components/GenericMenuItem';

import { ChildrenList, SubmenuListItem } from './styles';

interface ISidebarSubmenuProps {
  submenu: ISidebarItem;
  index: number;
  openSubmenuId: string;
  setOpenSubmenuId: Dispatch<SetStateAction<string>>;
}
// eslint-disable-next-line prettier/prettier
export const SidebarSubmenu: FC<ISidebarSubmenuProps> = ({
  submenu,
  index,
  openSubmenuId,
  setOpenSubmenuId,
}) => {
  const { asPath: fullPath } = useRouter();

  // A query string fica de fora da comparação de rota ativa — só o path importa.
  const asPath = useMemo(() => fullPath.split('?')[0], [fullPath]);

  const colapse = useCallback(() => {
    setOpenSubmenuId((prev) => (prev === submenu.key ? null : submenu.key));
  }, [setOpenSubmenuId, submenu]);

  useEffect(() => {
    if (openSubmenuId === submenu.key) {
      const split = asPath.split('/');
      if (split.length === 1) {
        colapse();
      }
    }
  }, [asPath, colapse, openSubmenuId, submenu.key]);

  const submenuLength = useMemo(
    () => submenu.children.length,
    [submenu.children.length]
  );

  const open = useMemo(
    () => openSubmenuId === submenu.key,
    [openSubmenuId, submenu]
  );

  const isChildActive = useMemo(() => {
    return (
      asPath.includes(`/${submenu.key}/`) ||
      submenu.children?.some(
        (child) => child.href && asPath.includes(child.href)
      )
    );
  }, [asPath, submenu]);

  return (
    <SubmenuListItem
      style={{
        height: open ? `${40 + submenuLength * 40}px` : '40px',
      }}
    >
      <GenericMenuItem
        id={submenu.key}
        as="div"
        icon={submenu.icon}
        title={submenu.label}
        iconHoverColor="primary"
        hoverColor="primary"
        hoverColorOpacity={0.25}
        iconColor={isChildActive ? 'primary' : 'neutral.500'}
        index={index}
        selected={false}
        key={String(index)}
        onClick={colapse}
        arrowState={open ? 'top' : 'bottom'}
        backgroundColor={open ? 'neutral.900' : 'neutral.950'}
      />

      <ChildrenList
        open={open}
        height={open ? `${submenuLength * 40}px` : '0px'}
      >
        {submenu.children.map((sub, _index) => {
          return (
            <GenericMenuItem
              withoutClick={!open}
              id={sub.key}
              key={String(_index)}
              index={_index}
              title={sub.label}
              iconHoverColor="primary"
              href={sub.href || `/${submenu.key}/${sub.key}`}
              selected={asPath.includes(
                sub.href || `/${submenu.key}/${sub.key}`
              )}
              paddingLeft="18px"
              hoverColor="primary"
              hoverColorOpacity={0.25}
              backgroundColor="neutral.900"
              currentColor="primary"
              currentIconColor="primary"
              currentOpacity={0.25}
              icon={sub.icon}
            />
          );
        })}
      </ChildrenList>
    </SubmenuListItem>
  );
};
